export default __webpack_public_path__ + "static/media/Hulk-huffman-compression.a69ec227.md";